<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
export default {
  name: "App",
  mounted() {
    // 页面加载时检测token
    const token = getToken();
    if (token) {
      console.log("用户已登录");
      this.$store.dispatch("initWebSocket", null, { root: true }).then((ws) => {
        console.log("WebSocket 已连接", ws);
        const loginMsg = {
          msgType: "6",
          token: getToken(),
        };
        this.$store
          .dispatch("sendMessage", JSON.stringify(loginMsg), {
            root: true,
          })
          .then(() => {
          });
      });
    } else {
      console.log("用户未登录登录");
    }
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue